import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WidgetSelect.html?raw';

import { DashboardTypes } from "./../../DashboardTypes";
class DashboardWidgetSelect extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private txtWidgetName: HTMLElement;
    private txtWidgetDescription: HTMLSpanElement;
    private data: DashboardTypes.DashboardWidget;

    private _isSelected: boolean = false;

    isSelected(): boolean {
        return this._isSelected;
    }
    private _onClickSelectWidget() {
        this._isSelected = !this._isSelected;
        this.UiModder.domClass.toggle(this.domNode, "selected", this._isSelected);
        this.emit("select");
    }
    getData(): DashboardTypes.DashboardWidget {
        return this.data;
    }
    setData(data: DashboardTypes.DashboardWidget) {
        this.data = data;

        this.UiModder.domClass.add(this.domNode, "hoverDark");

        this.UiModder.domAttr.set(this.txtWidgetName, "innerHTML", data.description);
        this.UiModder.domAttr.set(this.txtWidgetDescription, "innerHTML", data.description_long);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DashboardWidgetSelect);
